import React,{ useState, useCallback }  from 'react'
import { Form, Input, Button,message,Row, Col} from 'antd'
import Main from '../../cpn/Main';
import { useYonghuUpdateMiMaMutation } from '../../store/DianShangYeWuApi';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setLogout} from '../../store/loginSlice'
import classes from './user.module.css'
function UserPassword() {
    const qy_name = JSON.parse(localStorage.getItem('jtg-caiwu_qy_name'));
    const [form] = Form.useForm();
    const [info,setInfo] = useState({})
    // //验证码倒计时
    // const [isNote, setIsNote] = useState(false);
    // const [time, setTime] = useState(null);
    // const timeRef = useRef();
    // useEffect(() => {
    //     if (time && time !== 0) {
    //         timeRef.current = setTimeout(() => {
    //             setTime((time) => time - 1);
    //         }, 1000);
    //     } else {
    //         setIsNote(false);
    //     }
    //     return () => {
    //         clearInterval(timeRef.current);
    //     };
    // }, [time]);
  
    // //获取验证码数据
    // const [getCode] = useYonghuUpdateCodeMutation();
    // //获取验证码
    // const getCodeBtn = () => {
    //     if(qy_name.includes('试用')){
    //         message.error('当前为试用版，不能修改密码！')    
    //         return;
    //     }
    //     setTime(60);
    //     setIsNote(true);
    //     getCode({
    //         phone:JSON.parse(localStorage.getItem('jtg-caiwu_yh_phone'))
    //     }).then((res) => {
    //         // console.log(res);
    //         if(res.data.Status==='success'){
    //             setTime(60);
    //             setIsNote(true);
    //         }
    //         if (res.data.Status === 'fail') {
    //             message.error('该手机号码未注册：'+ res.data.Message)    
    //         }
    //     })    
    // }
    const [submit] = useYonghuUpdateMiMaMutation()
    //退出登录
    const navi = useNavigate();  
    const dispatch = useDispatch();
    const logout = useCallback(() => {
        navi('/WebLogin');
        dispatch(setLogout());    
    },[dispatch, navi]);    
    return (
            <Main  selectedKeys={['/UserPassword']}>
                <Row>
                    <Col span={2}></Col>
                    <Col span={8} className={classes.formAdd}>      
                        <Form
                            form={form}
                            layout="horizonal"
                            name="form_client"
                            initialValues={{modifier: 'public',}}
                            labelCol={{ span: 5 }}  
                            onFinish={() => {
                                if(qy_name.includes('试用')){
                                    message.error('当前为试用版，不能修改密码！')    
                                    return;
                                }
                                submit({
                                    yh_qy_name:JSON.parse(localStorage.getItem('jtg-caiwu_qy_name')),
                                    yh_phone:JSON.parse(localStorage.getItem('jtg-caiwu_yh_phone')),
                                    yh_mima:info.yh_mima,
                                }).then((res) => {
                                    console.log(res);
                                    if(res.data.Status==='success'){
                                        message.success('修改成功，请使用新密码登录！')
                                        form.resetFields();
                                        logout()
                                    }
                                    if (res.data.Status === 'fail') {
                                        message.error('该手机号码未注册：'+ res.data.Message)    
                                    }
                                })
                            }}                  
                        >
                            <Form.Item
                                label='新密码'
                                name="newPassword"
                                validateTrigger="onBlur"
                                rules={[{
                                    required: true,
                                    message: '请填写新密码!',
                                },
                            ]}
                                wrapperCol={{span:16}}
                            >
                                <Input 
                                    placeholder="请输入新密码" 
                                    onChange={(e) => {setInfo(prevState=>({...prevState,yh_mima:e.target.value}))}}   
                                    type='password'                          
                                />
                            </Form.Item>                                            
                        
                            <Form.Item
                                wrapperCol={{span:15,offset:"5"}}
                            >
                                <Button
                                    type='primary'
                                    htmlType='submit'
                                >保存</Button>
                            </Form.Item>                    
                        </Form>
                    </Col>
                    <Col span={4}></Col>
                </Row>
            </Main>
    )
}

export default UserPassword